import { useMutation } from '@apollo/react-hooks';
import { CartIdContext } from '@jetshop/core/components/Cart/CartIdContext';
import { addToCartSuccess } from '@jetshop/core/components/Mutation/AddToCart/addToCartUtils';
import uniqueId from '@jetshop/core/helpers/uniqueId';
import React, { useContext } from 'react';
import { useNotification } from '@jetshop/core/components/Notifications';
import { addToCart } from './queries/addToCart.gql';
import ProductToastWrapper from '../ProductPage/AddToCart/ProductToast';
import { useDynamicPrice } from '@jetshop/core/hooks/useDynamicPrice';

const AddToCart = ({
  children,
  product,
  selectedVariation = null,
  quantity = 1
}) => {
  const { cartId, setCartId } = useContext(CartIdContext);
  const [trigger] = useNotification();
  const articleNumber =
    selectedVariation?.articleNumber || product.articleNumber;

  const price = useDynamicPrice(product, selectedVariation);

  const [add] = useMutation(addToCart, {
    variables: {
      input: {
        cartId,
        articleNumber,
        quantity: quantity
      }
    },
    onCompleted: data => {
      trigger(
        <ProductToastWrapper
          selectedVariation={selectedVariation}
          product={product}
          quantity={quantity}
          price={price}
        />,
        {
          id: uniqueId,
          type: 'add-to-cart'
        }
      );
      addToCartSuccess({ cartId, setCartId })({ data });
    }
  });
  return children(add);
};

export default AddToCart;
